module.exports = __webpack_public_path__ + "img/7311901.2ecca39e.jpg";